import { z } from 'my-zod'
import { customerOrderPaymentMethodModel } from './customer-order-payment-method-model'

export const customerOrderPaymentMethodSystemView = customerOrderPaymentMethodModel

export type customerOrderPaymentMethodSystemView = z.infer<typeof customerOrderPaymentMethodSystemView>
